export default "__VITE_ASSET__CQSGMC0H__"